// Min 12 chars, no complexity class requirement (NIST 800-63B: length
// beats complexity for real-world passwords). Firebase Auth still
// rejects empties etc. on the server side. Single source of truth for
// every sign-up surface (sign-up screen, auth gate, anonymous upgrade).
export const MIN_PASSWORD_LENGTH = 12;

// Master switch for anonymous Fire Scout writes. While false, anonymous
// accounts can browse but not post/comment/like/upload, the Scout CTA and
// the silent scout sign-in are hidden, and write attempts route to the
// upgrade (save-account) sheet. Existing anonymous accounts stay signed in
// and keep the upgrade path (linkWithCredential preserves the uid).
//
// Revert: grep -rn ANON_WRITES_ENABLED — flip this const, the matching
// functions in firestore.rules and storage.rules, re-enable the two
// disabled Maestro flows, and invert the flag-off rules tests.
export const ANON_WRITES_ENABLED = false;

export function anonWritesBlocked(user: { isAnonymous?: boolean } | null | undefined): boolean {
  return !ANON_WRITES_ENABLED && !!user?.isAnonymous;
}
